import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { ScatterChartSpecification } from '../../../../dataModels/data-models';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'basic-scatter-chart',
    templateUrl: 'basicScatterChart.component.html',
    styleUrls: ['basicScatterChart.component.css']
})

export class BasicScatterChart implements OnInit {
    @Input() chartSpecification: ScatterChartSpecification;
    drawIt: boolean = false;

    constructor(private chartsService: ChartsService) { }

    ngOnInit() {
        setTimeout(() => {
            this.chartsService.notifyMe.subscribe(() => this.drawChart());

            this.drawChart();
        }, 0);
    }

    drawChart() {
        setTimeout(() => {
            let data = this.chartsService.getCoordinatesGroupedByProperty(this.chartSpecification.data,
                this.chartSpecification.groupBy, this.chartSpecification.xAxis, this.chartSpecification.yAxis,
                this.chartSpecification.value);

            this.drawIt = data.length > 0 ? true : false;
            let graphs = this.getGraphs();

            AmCharts.makeChart(this.chartSpecification.divId, {
                "type": "xy",
                "theme": "none",
                "mouseWheelZoomEnabled": true,
                "autoMarginOffset": 20,
                "legend": {
                    "useGraphSettings": true,
                    "align": "center",
                    "valueWidth": 50
                },
                "dataProvider": data,
                "valueAxes": [{
                    "position": "bottom",
                    "axisAlpha": 0,
                    "dashLength": 1,
                    "title": this.chartSpecification.xAxisTitle
                }, {
                        "axisAlpha": 0,
                        "dashLength": 1,
                        "position": "left",
                        "title": this.chartSpecification.yAxisTitle
                    }],
                "startDuration": 1,
                "titles": [
                    {
                        "text": this.chartSpecification.title,
                        "size": 15
                    }
                ],
                "graphs": graphs,
                "marginLeft": 64,
                "marginBottom": 60,
                "chartScrollbar": {},
                "chartCursor": {},
                "export": {
                    "enabled": true,
                    "position": "bottom-right",
                    "fileName": this.chartSpecification.title
                }
            });

        }, 20);
    }

    getGraphs() {
        let groups = this.chartsService.getValuesOfProperty(this.chartSpecification.data, this.chartSpecification.groupBy);
        let graphs = [];
        let bulletIndex = 0;

        for (let i = 0, bulletIndex = 0; i < groups.length; i++ , bulletIndex++) {
            bulletIndex = bulletIndex % this.chartsService.chartbullets.length;

            graphs.push({
                "balloonText": this.chartSpecification.groupBy + ": " + groups[i] + ", " + this.chartSpecification.value + ": [[description]]",
                "bullet": this.chartsService.chartbullets[bulletIndex],
                "lineAlpha": 0,
                "xField": groups[i] + "x",
                "yField": groups[i] + "y",
                "lineColor": this.chartsService.chartColors[i],
                "fillAlphas": 0,
                "title": this.chartSpecification.groupBy + ": " + groups[i],
                "descriptionField": "PointText",
                "valueText": "PointText"
            });
        }

        return graphs;
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/scatterCharts/basicScatterChart/basicScatterChart.component.ts